module.exports = __webpack_public_path__ + "img/product_1_playlists.f48530ae.png";